import { CommonModule } from '@angular/common';
import { Component, OnInit, AfterViewInit  } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { InfoService } from '../../services/infos/infos.service';
import { CardsService } from '../../services/cards.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-card',
  standalone: true,
  imports: [RouterModule, CommonModule],
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss']
})
export class CardComponent implements OnInit, AfterViewInit  {

  items: any[] = [];
  paginatedItems: any[] = [];
  currentPage: number = 1;
  itemsPerPage: number = 12;
  totalPages: number = 0;
  paginationDots: number[] = [];
  data: any;
  loading: boolean = false;

  constructor(private router: Router, private infoService: InfoService, private cardsService: CardsService) { }

  ngOnInit(): void {
    this.loading = true;
    this.getInfoCardsCodigo();
    this.getCards();
    this.getCards();
    this.updatePaginationDots();
  }

  ngAfterViewInit(): void {
  }

  getInfoCards2(codEntidadeNegocio: number, codCatalogo: number) {
    this.cardsService.getInfoCards(codEntidadeNegocio, codCatalogo).subscribe(
      res => {
        console.log('res', res);
      },
      error => {
        console.error('Erro ao buscar informações:', error);
      }
    );
  }
  
  getInfoCards() {
    this.cardsService.getInfoCards(19045, 13215).subscribe(
      res => {
        console.log('Respostas dos Cards:', res);
      },
      error => {
        console.error('Erro ao buscar os cards', error);
      },
      () => {
        this.loading = false;
      }
    );
  }

  getInfoCardsCodigo() {
    this.infoService.getInfos().subscribe(
      res => {
        console.log('Respostas InfoCardsCodigo:', res);
      },
      error => {
        console.error('Erro ao buscar informações:', error);
      },
      () => {
        this.loading = false;
      }
    );
  }

  getCards() {
    this.cardsService.getCards().subscribe({
      next: (res) => {
        this.data = res;
        console.log('Resposta Cards:', this.data.data);
  
        this.items = this.transformData(this.data.data.valorMetadado);
        console.log('Itens transformados:', this.items);
        this.totalPages = Math.ceil(this.items.length / this.itemsPerPage);
        this.updatePaginatedItems();
        this.updatePaginationDots();
      },
      error: (error) => {
        console.error('Erro ao obter os dados', error);
      },
      complete: () => {
        this.loading = false;
      }
    });
  }  

  transformData(data: any[]) {
    const items: { codEntidadeNegocio: any; nome: string; count: any; icon: string; }[] = [];

    data.forEach(item => {
      for (const key in item) {
        const count = item[key];

        if (count && key.toLowerCase().startsWith('qtd')) {
          const formattedName = this.formatName(key.replace(/^qtd_/i, ''));
          items.push({
            codEntidadeNegocio: item.codCatalogo,
            nome: formattedName,
            count: count,
            icon: `/assets/svg/${formattedName.toLowerCase().replace(/ /g, '_')}.svg`,
          });
        }
      }
    });

    console.log("Itens filtrados:", items);
    return items;
  }

  formatName(name: string): string {
    return name
      .replace(/_/g, ' ')
      .toLowerCase()
      .replace(/\b\w/g, char => char.toUpperCase());
  }

  updatePaginatedItems() {
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    const endIndex = startIndex + this.itemsPerPage;
    this.paginatedItems = this.items.slice(startIndex, endIndex);
  }

  updatePaginationDots() {
    this.paginationDots = Array.from({ length: this.totalPages }, (_, i) => i + 1);
  }

  goToPage(page: number) {
    if (page >= 1 && page <= this.totalPages) {
      this.currentPage = page;
      this.updatePaginatedItems();
      this.updatePaginationDots();
    }
  }

  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.updatePaginatedItems();
      this.updatePaginationDots();
    }
  }

  previousPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.updatePaginatedItems();
      this.updatePaginationDots();
    }
  }

  navigateToInfo(name: string) {
    this.router.navigate([`/info/${name}`]);
  }
}

